import { render } from "./AppPrivacy.vue?vue&type=template&id=257c3661&scoped=true"
import script from "./AppPrivacy.vue?vue&type=script&lang=js"
export * from "./AppPrivacy.vue?vue&type=script&lang=js"

import "./AppPrivacy.vue?vue&type=style&index=0&id=257c3661&scoped=true&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257c3661"]])

export default __exports__